import cls from "./LineHeader.module.css";
const LineHeader = () => {
    return (
        <div className={cls.LineHeader} />
    )
}

export default LineHeader;
